import { useEffect, useState } from "react";
import { MapConfig } from "../components/common/vjt-map/props";

export function useConfig()
{
    const [config, setConfig] = useState<MapConfig | null>(null);

    useEffect(() =>
    {
        const url = process.env.REACT_APP_STAGE !== "dev"
            ? "/config/config.json"
            : "/config.json";

        fetch(url)
            .then(res => res.json())
            .then(data => setConfig(data.map))
            .catch(err => console.error("Failed to load map config:", err));
    }, []);

    return config;
}
